module.exports = __webpack_public_path__ + "img/banner1.18f06eb6.png";